/* eslint-disable */
const RETAIL = {
  RETAIL_COMPANY_DELIVERYPACK_SIGN: 'retail/company/deliveryPack/sign',
  RETAIL_COMPANY_PLAN_EDIT_DELIVERYPACK: 'retail/company/plan/edit/deliveryPack',
  RETAIL_COMPANY_PLAN_ASSIGN: 'retail/company/plan/assign',
  RETAIL_COMPANY_PLAN_EDIT_DRIVER: 'retail/company/plan/edit/driver',
  RETAIL_COMPANY_DELIVERYPACK_REJECT: 'retail/company/deliveryPack/reject',
  RETAIL_COMPANY_DELIVERYPACK_REASSGIN: 'retail/company/deliveryPack/reassign',
  RETAIL_MANAGE_LOCATION_DRIVER_LIST: 'retail/manage/location/driver/list',
  RETAIL_MANAGE_TRAJECTORY_DRIVER_CURRENT: 'retail/manage/trajectory/driver/current',
  RETAIL_MANAGE_TRAJECTORY_DRIVER_RANGE: 'retail/manage/trajectory/driver/range',
  RETAIL_MANAGE_TRAJECTORY_DRIVER_DELIVERY: 'retail/manage/trajectory/driver/delivery',

  RETAIL_MANAGE_DRIVER_LEAVE_REPORT: 'retail/manage/driver/leave/report',
  RETAIL_MANAGE_DRIVER_LEAVE_EDIT: 'retail/manage/driver/leave/edit',
  RETAIL_MANAGE_DISPATCH_CLOSE: 'retail/manage/dispatch/close',
  RETAIL_MANAGE_DISPATCH_OPEN: 'retail/manage/dispatch/open',
  RETAIL_MANAGE_DISPATCH_DELIVERY_CONFIRM: 'retail/manage/dispatch/delivery/confirm',
  RETAIL_MANAGE_DRIVER_LEAVE_RECORD: 'retail/manage/driver/leave/record',
  RETAIL_MANAGE_DISPATCH_DETAILITEM_EDIT: 'retail/manage/dispatch/detailItem/edit',
  RETAIL_MANAGE_DISPATCH_DETAILITEM_DELETE: 'retail/manage/dispatch/detailItem/delete',
  RETAIL_MANAGE_DISPATCH_DETAIL_UNDOFINISH: 'retail/manage/dispatch/detail/undoFinish',
  RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_ADD: 'retail/operator/deliveryPack/payment/add',
  RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_DELETE: 'retail/operator/deliveryPack/payment/delete',
  RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_EDIT: 'retail/operator/deliveryPack/payment/edit',
  REPORT_RETAIL_LIST_FREE_DRIVERS: 'report/retail/list/free/drivers',
  REPORT_RETAIL_LIST_FREE_CARS: 'report/retail/list/free/cars',
  REPORT_RETAIL_LIST_CARS: 'report/retail/list/cars',
  REPORT_RETAIL_PURCHASE_DELIVERYPACK: 'report/retail/purchase/deliveryPack',
  RETAIL_COMPANY_EDITEDADDRESSES_CONFIRM: 'retail/company/editedAddresses/confirm',
  RETAIL_COMPANY_SETLLEMENT_PAYMENTS: 'retail/company/settlement/payments',
  RETAIL_COMPANY_SETLLEMENT_CONFIRM: 'retail/company/settlement/confirm',

  RETAIL_COMPANY_SETLLEMENT_DELETE: 'retail/company/settlement/delete',

  RETAIL_COMPANY_SETLLEMENT_EXIST: 'retail/company/settlement/exist',

  RETAIL_MANAGE_SPEED_DRIVER_RANGE: 'retail/manage/speed/driver/range'
}
export default RETAIL
